import * as types from './types';
import { get } from 'lodash';
import { fetchPost } from '../api/fetch';
import { openSnackBar } from '../actions/snackbarAction';
import { logOut } from '../actions/loginActions';

export function onHomeworkResponse(response) {
  return {
    type: types.HOMEWORK_RESPONSE,
    response
  };
}
export function homeworkDetailsResponse(response) {
  return {
    type: types.HOMEWORK_DETAILS_RESPONSE,
    response
  };
}

export const homeworkList = async (params, dispatch) => {
  const jwtToken = params;
  const body = {};
  const url = 'api/dc/student/homework';
  return await fetchPost(url, body, jwtToken)
    .then(res => {
      return res.json();
    })
    .then(data => {
      if (data.error || !Object.keys(data).includes('data')) {
        dispatch(
          openSnackBar({ message: 'Some error occurred', severity: 'error' })
        );
        return 'Error';
      }
      if (!get(data, 'IsLoggedIn', true)) {
        dispatch(
          openSnackBar({
            message: 'Multiple logins detected, please login again to continue',
            severity: 'warning'
          })
        );
        dispatch(logOut());
        return 'Logged Out';
      }
      dispatch(onHomeworkResponse(data));
      return onHomeworkResponse(data);
    })
    .catch(() => {
      return 'Error';
    });
};

export const homeWorkDetail = async (params, UniqueCode, dispatch) => {
  const jwtToken = params;
  const body = {
    UniqueCode: UniqueCode
  };
  const url = 'api/dc/student/homework';
  return await fetchPost(url, body, jwtToken)
    .then(res => {
       return res.json();
    })
    .then(data => {
      if (data.error || !Object.keys(data).includes('data')) {
        dispatch(
          openSnackBar({ message: 'Some error occurred', severity: 'error' })
        );
        return 'Error';
      }
      if (!get(data, 'IsLoggedIn', true)) {

        dispatch(
          openSnackBar({
            message: 'Multiple logins detected, please login again to continue',
            severity: 'warning'
          })
        );
        dispatch(logOut());
        return 'Logged Out';
      }
      dispatch(homeworkDetailsResponse(data));
      return homeworkDetailsResponse(data);
    })
    .catch(() => {
      return 'Error';
    });
};
